/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { Constants as LibConstants, Milliseconds, Seconds } from '@wit/vtv-x-foundation-lib';

interface Constants extends LibConstants {
  // ON DEMAND
  MAX_ASSETS_PER_RAIL: number;
  ASSETS_PER_GRID_PAGE: number;

  // WATCH TV
  WATCHTV_CHANNEL_CARD_PROGRESS_REFRESH_RATE: Milliseconds;
  WATCHTV_MAX_TOP_CHANNELS: number;

  // SEARCH
  MAX_ASSETS_PER_RAIL_SEARCH_RESULTS: number;
  MAX_ASSETS_PER_RAIL_SEARCH_RECENT: number;

  // PIN MODAL
  HELP_LINK: string;

  // MY TV
  MAX_ASSETS_WATCH_NEXT: number;

  // PLAYER
  VISUAL_SCRUBBER_SIDE_CARDS: number;
  PLAYER_MAX_ASSETS_WATCH_NEXT: number;

  // AUDIO AND SUBTITLES
  AUDIO_DESCRIPTION_LABEL: string;
  SUBTITLES_HARD_OF_HEARING_LABEL: string;

  // RECOMM
  RECOMM_UPNEXT_SIDE_SUGGESTION_THRESHOLD: Seconds;
  RECOMM_MAX_ASSETS_SOMETHING_ELSE: number;

  // SCROLL HEADER DISTANCES
  HEADER_INIT_TOP_OFFSET: number;
  HEADER_TOP_OFFSET_TRIGGER_TO_FADE: number;
}

const Constants: Constants = {
  ...LibConstants,

  // ON DEMAND
  MAX_ASSETS_PER_RAIL: 12,
  ASSETS_PER_GRID_PAGE: 24,

  // WATCH TV
  WATCHTV_CHANNEL_CARD_PROGRESS_REFRESH_RATE: 5000,
  WATCHTV_MAX_TOP_CHANNELS: 8,

  // SEARCH
  MAX_ASSETS_PER_RAIL_SEARCH_RESULTS: 12,
  MAX_ASSETS_PER_RAIL_SEARCH_RECENT: 20,

  // PIN MODAL
  HELP_LINK: 'http://vodafone.com',

  // MY TV
  MAX_ASSETS_WATCH_NEXT: 20,

  // PLAYER
  VISUAL_SCRUBBER_SIDE_CARDS: 2,
  PLAYER_MAX_ASSETS_WATCH_NEXT: 3,

  // AUDIO AND SUBTITLES
  AUDIO_DESCRIPTION_LABEL: 'AD', // According to SI012.005 this keywords shall never be translated
  SUBTITLES_HARD_OF_HEARING_LABEL: 'HH', // According to SI012.005 this keywords shall never be translated

  // RECOMM
  RECOMM_UPNEXT_SIDE_SUGGESTION_THRESHOLD: 5,
  RECOMM_MAX_ASSETS_SOMETHING_ELSE: 6,

  HEADER_INIT_TOP_OFFSET: 0,
  HEADER_TOP_OFFSET_TRIGGER_TO_FADE: 100,
};

export default Constants;
